import ReactImg from "../src/Images/react.png";
import KotlinImg from "../src/Images/kotlin_android.png";
import FlutterImg from "../src/Images/flutter.png";
import NodeImg from "../src/Images/nodejs.jpeg";
import SQLImg from "../src/Images/sql.jpg";
import NoSQLImg from "../src/Images/nosql.jpg";

const Courses = [
  {
    imgsrc: ReactImg,
    title: "Frontend with React",
    content:
      "Learn to build responsive web-applications with react, along with Bootstrap 5.",
    link: `https://www.youtube.com/watch?v=tiLWCNFzThE&list=PLwGdqUZWnOp3aROg4wypcRhZqJG3ajZWJ&ab_channel=ThapaTechnical`,
  },
  {
    imgsrc: KotlinImg,
    title: "Android with Kotlin",
    content:
      "Learn Kotlin from beginner to advanced, and build Android applications with Kotlin. ",
    link: `https://www.youtube.com/watch?v=VEqhzCFmEQI&list=PLlxmoA0rQ-LwgK1JsnMsakYNACYGa1cjR&ab_channel=Smartherd`,
  },
  {
    imgsrc: NodeImg,
    title: "Backend with Node.js",
    content: "Learn Backend Development with JavaScript, using Node.js. ",
    link: `https://www.youtube.com/watch?v=IIpiLZGTWuo&list=PLwGdqUZWnOp00IbeN0OtL9dmnasipZ9x8`,
  },
  {
    imgsrc: FlutterImg,
    title: "Cross-platform with Flutter",
    content:
      "Learn to build Native Apps on IOS, as well as Android from a single codebase. ",
    link: `https://www.youtube.com/watch?v=1ukSR1GRtMU&list=PL4cUxeGkcC9jLYyp2Aoh6hcWuxFDX6PBJ`,
  },
  {
    imgsrc: SQLImg,
    title: "Databases with MySQL",
    content:
      "Learn to create, store, delete and retrieve from databases using SQL. ",
    link: `https://www.youtube.com/watch?v=fV8ointgMeQ&list=PLwGdqUZWnOp2R_BVnHPqD3aMg7wHWlL8k`,
  },
  {
    imgsrc: NoSQLImg,
    title: "NoSQL Databases",
    content:
      "Learn all about non-tabular databases like MongoDB, CouchDB, Google Firebase, etc. ",
    link: `https://www.youtube.com/watch?v=9OPP_1eAENg&list=PL4cUxeGkcC9jpvoYriLI0bY8DOgWZfi6u`,
  },
];

export default Courses;
